import { useCallback } from 'react';
import type { ComponentProps } from 'react';
import type React from 'react';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { DownloadFlyerTask } from './components/DownloadFlyerTask';

async function LoadDownloadFlyerTask({
	errorReporter,
}: UtilityContext): Promise<typeof DownloadFlyerTask | (() => null)> {
	try {
		return (
			await import(
				/* webpackChunkName: "pages/starter-dashboard-qr-code-flyer-task" */ './components/DownloadFlyerTask'
			)
		).DownloadFlyerTask;
	} catch (error) {
		const err = error instanceof Error ? error : new Error('Unknown error: Failed to load DownloadFlyerTask component');
		void errorReporter.report({ error: err, params: { event: 'LoadDownloadFlyerTask' } });
		return () => null;
	}
}

type Props = ComponentProps<typeof DownloadFlyerTask>;

export const DownloadFlyerTaskLoader: React.FC<Props> = (props) => {
	const utilityContext = useUtilityContext();
	const loadComponent = useCallback(async () => LoadDownloadFlyerTask(utilityContext), [utilityContext]);

	return <LazyComponent loadComponent={loadComponent} fallback={<div></div>} {...props} />;
};
